import styled from 'styled-components';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout';

export const ProSelectInputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  font-family: Lato, sans-serif;

  &:after {
    content: "";
    position: absolute;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC43MjIgMTAuMTY3YTEgMSAwIDAxLTEuNDQ0IDBMMS4xNTIgMS42OTJDLjU0MiAxLjA1Ni45OTIgMCAxLjg3NCAwaDE2LjI1MmMuODgxIDAgMS4zMzIgMS4wNTYuNzIyIDEuNjkybC04LjEyNiA4LjQ3NXoiIGZpbGw9IiM2MDdEOEIiLz48L3N2Zz4=);
    background-repeat: no-repeat;
    height: 16px;
    width: 18px;
    background-position: 50%;
    right: 24px;
    bottom: 16px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    pointer-events: none;
    box-sizing: border-box;
  }
`;

export const StyledProSelectInput = styled.select`
  border: 2px solid ${palette.steelTeal};
  margin: 0;
  outline: 0;
  padding: 22px 16px;
  color: ${palette.footerBackground};
  border-radius: 4px;
  transition: all .3s ease-in-out;
  font-size: 16px;
  font-weight: 300;
  font-family: Lato, sans-serif;
  letter-spacing: normal;
  line-height: normal;
  -webkit-appearance: none;
  cursor: pointer;

  > option {
    cursor: pointer;
    padding: 2px;
    display: block;
    font-size: 16px;

    @media screen and (min-width: ${layout.sm}) {
      font-size: 18px;
    }
  }
`;

export const ProPlaceholderOption = styled.option`
  color: ${palette.fog};
  cursor: pointer;
`;
